import React, {useEffect, useState} from 'react';
import CustomInput from "../../../components/UI/customInput/customInput";
import {Link} from "react-router-dom";
import DatePickerCustom from "../../../components/datePicker/datePicker";
import CustomSelect from "../../../components/UI/customSelect/customSelect";
import CustomTextArea from "../../../components/UI/customTextArea/customTextArea";
import {Get, Post} from "../../../apis/api";
import {toast} from "react-toastify";
import {useSelector} from "react-redux";
import CustomButton from "../../../components/UI/customButton/customButton";
import moment from "moment-jalaali";

const InformationSection = ({ userId , data , setStep}) => {
  const [form, setForm] = useState({})
  const [loading, setLoading] = useState(false);
  const stateList = useSelector((state) => state.setting.province)
  const [jobs, setJobs] = useState( [] )
  const user = useSelector((state) => state.user.user)

  const gender = [
    {name:"male" , id:1} ,
    {name:"female" , id:2} ,
  ]
  const handleForm = ({name, value}) => {
    setForm((prevState) => ({...prevState, [name]: value}))
  }
  const handleSubmit = () => {
    setLoading(true);
    Post(`${user?.role_key === "super_admin" ? "admin" : "agent"}/crews/${data?.id || userId}/update`, { ...form , "form" :  `${user?.role_key === "super_admin" ? "admin" : "agent"}_update_form` , birth_date:moment(form.birth_date).format('YYYY-MM-jDD'  ) , passport_expire:moment(form.passport_expire).format('YYYY-MM-jDD'  )})
      .then((res) => {
        toast.success(res?.msg)
        setStep(3)
      })
      .catch((error) => {
        toast.error(error.data.message || error.data.msg)
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleJobsDefault = (id) => {
    return jobs?.find((item => {
      return (
        item.id === id
      )
    }))
  }

  const handleGenderDefault = (id) => {
    return gender?.find((item => {
      return (
        item.id === id
      )
    }))
  }

  const handleJobs = () => {
    setLoading(true)
    Get(`agent/profile/jobs?per_page=${100}` ).then((res) =>{
      setJobs(res?.details?.data?.data)
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    handleJobs()
  } ,[])

  useEffect(() => {
    setForm(data)
  } ,[data])


  console.log(form)
  return (
    <div className={"mt-8 flex flex-col gap-5"}>
      <div className={"my-container rounded-lg flex flex-col gap-5 w-full bg-white p-5 px-5 md:px-[15%]"}>
       <span className={"text-gray-500"}>
         {"To create a new crew member, please complete the information below."}
       </span>
        <div className={"grid grid-cols-1 md:grid-cols-2  gap-8"}>
          <DatePickerCustom
            name={"birth_date"}
            placeholder={"Date of Birth"}
            onChange={handleForm}
            noTime={false}
            en
            defaultValue={moment(form.birth_date).format('YYYY-MM-jDD'  )}
          />
          <CustomInput
            placeHolder={"Place of Birth"}
            label={"Place of Birth"}
            name={"place_of_birth"}
            onchange={handleForm}
            defaultValue={form["place_of_birth"]}
          />
          <CustomSelect
            options={jobs}
            placeHolder={"job name"}
            label={"job name"}
            name={"job_id"}
            enName={true}
            defaultValue={handleJobsDefault(form["job_id"])}
            onchange={handleForm}
          />
          <CustomSelect
            options={gender}
            placeHolder={"gender "}
            label={"gender "}
            name={"gender"}
            enName={true}
            defaultValue={handleGenderDefault(form["gender"])}
            onchange={handleForm}
          />
          <span className={"w-full"}>
             <CustomInput
               placeHolder={"Father's Name"}
               label={"Father's Name"}
               name={"father_name"}
               onchange={handleForm}
               defaultValue={form["father_name"]}
             />
          </span>
          <span className={"w-full"}>
             <CustomInput
               placeHolder={"nationality"}
               label={"nationality"}
               name={"nationality"}
               onchange={handleForm}
               defaultValue={form["nationality"]}

             />
          </span>
          <span className={"w-full"}>
             <CustomInput
               placeHolder={"Passport NO."}
               label={"Passport NO."}
               name={"passport_no"}
               onchange={handleForm}
               defaultValue={form.passport_no}

             />
          </span>
          <DatePickerCustom
            name={"passport_expire"}
            placeholder={"Passport Expiration Date"}
            onChange={handleForm}
            noTime={false}
            en
            defaultValue={moment(form.passport_expire).format('YYYY-MM-jDD'  )}
          />
          <span className={"w-full"}>
             <CustomInput
               placeHolder={"Passport Country"}
               label={"Passport Country"}
               name={"passport_country"}
               onchange={handleForm}
               defaultValue={form["passport_country"]}

             />
          </span>

          <DatePickerCustom
            name={"cdc_expire"}
            placeholder={"CDC expire date"}
            onChange={handleForm}
            noTime={false}
            en
            defaultValue={moment(form.cdc_expire).format('YYYY-MM-jDD'  )}

          />

          <span className={"w-full"}>
             <CustomInput
               placeHolder={"CDC NO."}
               label={"CDC NO."}
               name={"cdc_no"}
               onchange={handleForm}
               defaultValue={form["cdc_no"]}

             />
          </span>

        </div>
      </div>
      <div className={"my-container rounded-lg flex flex-col gap-5 w-full bg-white p-5 px-5 md:px-[15%] "}>
        <div className={"grid grid-cols-1 md:grid-cols-2  gap-8 "}>

          <span className={"w-full"}>
             <CustomInput
               placeHolder={"Career Type"}
               label={"Career Type"}
               name={"career_type"}
               onchange={handleForm}
               defaultValue={form["career_type"]}

             />
          </span>
          <span className={"w-full"}>
             <CustomInput
               placeHolder={"Email"}
               label={"Email"}
               name={"email"}
               onchange={handleForm}
               defaultValue={form["email"]}

             />
          </span>
          <span className={"w-full"}>
             <CustomInput
               placeHolder={"Phone NO."}
               label={"Phone NO."}
               name={"phone"}
               onchange={handleForm}
               defaultValue={form["phone"]}

             />
          </span>

          <span className={"w-full"}>
             <CustomInput
               placeHolder={"Workplace Phone NO."}
               label={"Workplace Phone NO."}
               name={"work_phone"}
               onchange={handleForm}
               defaultValue={form["work_phone"]}

             />
          </span>

          <span className={"w-full"}>
             <CustomTextArea
               placeHolder={"Home Address"}
               label={"Home Address"}
               name={"home_address"}
               onchange={handleForm}
               defaultValue={form["home_address"]}

             />
          </span>

          <span className={"w-full"}>
             <CustomTextArea
               placeHolder={"Work Address"}
               label={"Work Address"}
               name={"work_address"}
               onchange={handleForm}
               defaultValue={form["work_address"]}

             />
          </span>

        </div>
      </div>
      <div className={"my-container pt-5 w-full"}>
        <div className={"w-full flex justify-between items-center"}>
          <Link to={"/crew"} className={"text-main"}>
            {"Close"}
          </Link>
          <div className={"w-[220px]"}>
            <CustomButton loading={loading} onClick={handleSubmit}  title={"Save Information"}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InformationSection;
